export const LABELS = {
  APPLICATION_FORM_LIST: "申請様式一覧",
  APPLICATION_FORM_REGIST: "申請様式登録",
  USAGE_ENABLE_FLAG: "利用状況",
  APPROVAL_STATUS: "承認ステータス",
  APPLYING_SERVICE_LABEL: "適用サービス",
  VERSION: "バージョン",
  FORM_TYPE_NAME: "様式種別",
  APPLYING_START_DATE: "適用開始日",

  ENABLE: "有効",
  INVALID: "無効",
};

// 一覧の1ページ当たりの件数
export const LIST_PAGE_SIZE = 20;

// 利用状況を文字に変換
export const getUsageSituation = (flag: boolean) => {
  if (flag === null) return "";
  if (flag) return LABELS.ENABLE;
  else return LABELS.INVALID;
};
